import React from 'react';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import News from './pages/News';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import AdvisoryBoard from './pages/AdvisoryBoard';
import ImpactStories from './pages/ImpactStories';
import Volunteer from './pages/Volunteer';
import Faq from './pages/Faq';
import PopupAnnouncementPage from './pages/PopupAnnouncementPage';
import PopupAnnouncementModal from './components/PopupAnnouncementModal';
import { popupAnnouncementService } from './services';
import './styles/index.css';


function App() {
    const [popupAnnouncement, setPopupAnnouncement] = useState(null);

    useEffect(() => {
        const fetchActivePopup = async () => {
            try {
                const activeResponse = await popupAnnouncementService.getActive();
                if (activeResponse.data?.id) {
                    setPopupAnnouncement(activeResponse.data);
                    return;
                }

                const listResponse = await popupAnnouncementService.getAll({ per_page: 1 });
                const fallback = listResponse.data?.data?.find((item) => item.status === 'active') || null;
                setPopupAnnouncement(fallback);
            } catch (error) {
                console.error('Error loading popup announcement:', error);
            }
        };

        fetchActivePopup();
    }, []);

    return (
        <Router>
            <div className="flex flex-col min-h-screen">
                <Navigation />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/projects/:id" element={<ProjectDetails />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/advisory-board" element={<AdvisoryBoard />} />
                        <Route path="/impact-stories" element={<ImpactStories />} />
                        <Route path="/volunteer" element={<Volunteer />} />
                        <Route path="/faq" element={<Faq />} />
                        <Route path="/announcements/:slug" element={<PopupAnnouncementPage />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/donate" element={<Donate />} />
                    </Routes>
                </main>
                <Footer />
            </div>
            <PopupAnnouncementModal announcement={popupAnnouncement} />
        </Router>
    );
}

export default App;
